import React, { forwardRef } from "react";
import "./Button.scss";
import Spinner from "../Spinner/Spinner";

interface ButtonProps {
  action: any;
  type?: any;
  name?: string;
  text?: any;
  children?: any;
  disabled?: any;
  loadingState?: any;
  id?: string;
  onKeyDown?: (e: any) => void;
}

const Button = ({
  action,
  type = "button",
  name = "",
  text,
  children,
  disabled = false,
  loadingState = false,
  id,
  onKeyDown,
}: ButtonProps) => {
  return (
    <div className="boxcenter" tabIndex={-1}>
      <button
        id={id}
        onClick={action}
        onKeyDown={onKeyDown}
        className={`${name} ${disabled || loadingState ? "disabledButton" : ""}`}
        type={type}
        disabled={disabled || loadingState}
      >
        {loadingState ? <Spinner /> : children || text}
      </button>
    </div>
  );
};

export default Button;
